
const state = {
  // PanelsEditPage requirements
  artworkId: null, // Current artwork id
  muted: true, // Whether or not the assets are muted
  editMode: true, // Whether or not the panels app is editing the scene or on the publishing screen
  assetThumbnails: {}, // Object of thumbnails for video assets the key is the fileID of an asset and the value is the url of the thumbnail

  maxAssetSize: 3, // In megabytes
};

const getters = {
  accumulatedAssetSize(state, getters, rootState, rootGetters) {
    const artwork = rootGetters.artworkById(state.artworkId);
    if (artwork && artwork.files) {
      const formatted = artwork.files
        .reduce((acc, el) => {
          return (acc += el.size / 1024 / 1024);
        }, 0)
        .toFixed(2);
      return Number.parseFloat(formatted);
    }
    return 0;
  },
  isNewAssetOverMaxSize(state, getters) {
    return file => {
      const sizeInMb = file.size / 1024 / 1024;
      return (sizeInMb + getters.accumulatedAssetSize) > state.maxAssetSize;
    };
  },
  sceneConfigHasChanged(state, getters, rootState, rootGetters) {
    const newSceneConfig = JSON.stringify(
      rootGetters['PanelsScene/sceneConfig'](state.artworkId)
    );
    const artwork = rootGetters.artworkById(state.artworkId);
    if (artwork && newSceneConfig) {
      const oldSceneConfig = artwork.sceneConfig;
      // Old scene graph doesn't exist (i.e. it's a new panels project) or there are new changes
      try {
        return !oldSceneConfig || newSceneConfig.trim() !== oldSceneConfig.trim();
      } catch (error) {
        console.error(error);
        return false;
      }
    }
    // If there's no artwork, default to false
    return false;
  }
};

const mutations = {
  SET_ARTWORK_ID(state, { artworkId }) {
    state.artworkId = artworkId;
  },
  // Thumbnails keyed by asset fileID (live VideoAlpha frames + one-shot GLB
  // renders). Merge rather than replace: the VideoAlpha generator re-emits its
  // full set each second while GLB thumbnails are emitted once on load, so a
  // replace would let one source clobber the other.
  SET_ASSET_THUMBNAILS(state, payload) {
    state.assetThumbnails = { ...state.assetThumbnails, ...payload };
  },
  SET_MUTED(state, { muted }) {
    state.muted = muted;
  },
  SET_EDIT_MODE(state, { editMode }) {
    state.editMode = editMode;
  },
  SET_MAX_ASSET_SIZE(state, payload) {
    state.maxAssetSize = payload.maxAssetSize;
  },
};

export default {
  state,
  getters,
  mutations,
  namespaced: true,
};
